import { MessageCircle } from "lucide-react";
import { MessagesList } from "../components/MessagesList";
import { useResponsive } from "@/hooks/use-responsive";

export function MessagesContent() {
  const { isDesktop } = useResponsive();
  
  return (
    <div className="flex flex-col h-full min-h-0 w-full">
      <div className={isDesktop ? "px-6 py-6 flex-none" : "container mx-auto px-4 py-6 max-w-4xl flex-none"}>
        <div>
          <div className="flex items-center gap-3 mb-2">
            <MessageCircle className="h-6 w-6 text-primary" />
            <h1 className="text-2xl font-bold text-foreground">Messages</h1>
          </div>
          <p className="text-muted-foreground">
            View all your messages and communications
          </p>
        </div>
      </div>

      <div className="flex-1 min-h-0 w-full">
        <MessagesList />
      </div>
    </div>
  );
}
